import BackButton from '../application/backButton';

const EmptyShortlist = ({
  login,
  hideBackButton,
  showLoginButton,
  showLoginMessage,
}: {
  hideBackButton: boolean;
  login: () => void;
  showLoginButton: boolean;
  showLoginMessage: boolean;
}): JSX.Element => (
  <div className="ac-shortlist__empty--container ch-container ch-display--flex ch-flex-direction--column ch-align-items--center ch-text--center">
    <BackButton hideButton={hideBackButton} />
    <div className="ac-shortlist__empty ch-display--flex ch-flex-direction--column ch-align-items--center ch-text--center">
      <h1>You haven&apos;t shortlisted any vehicles yet</h1>
      <h4 className="ch-fw--400 ch-color--grey-6 ch-mh--auto ch-width--10 ch-mb--3 sm:ch-fs--4 sm:ch-mb--4 ch-lh--body">
        {showLoginMessage
          ? 'Start adding or access your previously shortlisted vehicles by logging in.'
          : 'Vehicles that you save to your shortlist will appear here.'}
      </h4>
      <a className="ch-btn ch-btn--success" href="/vehicles">
        Start my search
      </a>
      {showLoginButton && (
        <button
          className="ch-btn ch-mt--2"
          data-gtm-track="click_cta"
          data-gtm-track-label="Login - Shortlist Button"
          onClick={login}
          type="button"
        >
          Log in
        </button>
      )}
    </div>
  </div>
);

export default EmptyShortlist;
